import Color from 'color';

export { Color };

export const primary = Color('#e2e5de');
export const secondary = Color('#f5f5f5');
export const tertiary = Color('#ffffff');
export const quaternary = Color('#b2beb5');
export const quinary = Color('#e0e0e0');
export const senary = Color('#ffffff');
export const septenary = Color('#ffffff');

export const black = Color('#000');
export const white = Color('#fff');
export const lightGray = Color('#808080');
export const gray = Color('#4a4c50');

export const green = Color('#53d449');
export const red = Color('#e6467f');

export const symbol = Color('#676767');
export const link = Color('#5d80d6');

export const accent = Color('#006437');

/*

676767
808080
ffffff
f5f5f5
e2e5de
b2beb5

*/